export default ({ user }) => {
  if (!user) {
    return false;
  }

  return true;
};
